import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';
import { StorageService } from 'src/app/shared/services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class FichaDaObraService {
  private responsavelSubject = new BehaviorSubject<any>(null);
  responsavel$ = this.responsavelSubject.asObservable();

  private responsavelSelecionadoSubject = new BehaviorSubject<any>(null);
  responsavelSelecionado$ = this.responsavelSelecionadoSubject.asObservable();

  constructor(
    private _requestService: RequestService,
    private _storageService: StorageService
  ) {}


  private comModulo(body: object, moduloId?: number | null): object {
    return moduloId ? { ...body, moduleId: moduloId } : body;
  }

  listaClienteMercado(idObra?: number): Observable<any> {
    let url = `work/DetailsSheet/ListMarketClientStatus`;
    if (idObra) {
      url += `?workId=${idObra}`;
    }
    return this._requestService.requestMethod(url, 'GET', true);
  }

  listarContatosObra(idObra: number, idModulo: number): Observable<any> {
    const url = `work/${idObra}/${idModulo}/contact-details`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  popularTarefaseAcoes(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Actions`,
      'GET',
      true,
      null
    );
  }

  popularResponsavelObra(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null
    );
  }

  updatePotencialObra(
    idObra: number,
    body: { score: number },
    moduloId?: number | null
  ): Observable<any> {
    const url = `work/${idObra}/set-potential`;
    return this._requestService.requestMethod(
      url,
      'PUT',
      true,
      this.comModulo(body, moduloId)
    );
  }

  updateClienteMercado(
    idObra: number,
    body: {
      marketID: number;
      description: string;
      responsibleID: number;
    },
    moduloId?: number | null
  ): Observable<any> {
    const url = `work/${idObra}/set-market`;
    return this._requestService.requestMethod(
      url,
      'PUT',
      true,
      this.comModulo(body, moduloId)
    );
  }

  updateResponsavelObra(
    idObra: number,
    body: { responsibleID: number },
    moduloId?: number | null
  ): Observable<any> {
    const url = `work/${idObra}/set-responsible`;
    return this._requestService.requestMethod(
      url,
      'PUT',
      true,
      this.comModulo(body, moduloId)
    );
  }

  detalheDaObra(idObra: number, moduloId?: number | null): Observable<any> {
    const url = moduloId ? `work/${idObra}/${moduloId}` : `work/${idObra}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  novaTarefa(idObra: number, data, moduloId?: number | null): Observable<any> {
    const url = `work/${idObra}/set-tasks`;
    return this._requestService.requestMethod(
      url,
      'POST',
      true,
      this.comModulo(data, moduloId)
    );
  }

  novoRelato(idObra: number, data, moduloId?: number | null): Observable<any> {
    const url = `work/${idObra}/set-reports`;
    const headers = { 'Content-Type': 'application/json' };
    return this._requestService.requestMethod(
      url,
      'POST',
      true,
      this.comModulo(data, moduloId),
      headers
    );
  }

  listarTarefasRelatos(idObra: number): Observable<any> {
    const url = `work/${idObra}/tasks-reports`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  updateStatusTarefa(idTask: number, status: number): Observable<any> {
    const url = `work/${idTask}/tasks/set-status/${status}`;
    return this._requestService.requestMethod(url, 'PUT', true);
  }

  updateTarefa(idObra: number, idTarefa: number, data: any): Observable<any> {
    const url = `work/${idObra}/tasks/${idTarefa}`;
    return this._requestService.requestMethod(url, 'PUT', true, data);
  }
  deletarTarefa(payload: { tasksID: string }): Observable<any> {
    const url = `work/discard-tasks`;
    return this._requestService.requestMethod(url, 'DELETE', true, payload);
  }

  deletarRelatos(idObra: number, idRelato: number): Observable<any> {
    const url = `work/${idObra}/discard-reports/${idRelato}`;
    return this._requestService.requestMethod(url, 'DELETE', true);
  }

    imagensCarrosselObra(idObra: number, moduloId?: number | null): Observable<any> {
    const url = moduloId ? `work/${idObra}/${moduloId}/images` : `work/${idObra}/images`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  listarArquivosObra(idObra: number, moduloId?: number | null): Observable<any> {
  const url = moduloId ? `work/${idObra}/${moduloId}/files` : `work/${idObra}/files`;
  return this._requestService.requestMethod(url, 'GET', true);
}

  setResponsavel(responsavel: any): void {
    this.responsavelSubject.next(responsavel);
  }

  setResponsavelSelecionado(responsavel: any): void {
    this.responsavelSelecionadoSubject.next(responsavel);
  }

  infoImpressao(data): Observable<any> {
    const url = `work/worksDetails`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  listarConcorrentes(): Observable<any> {
    const url = `work/Competitors`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  listarMotivoPerda(): Observable<any> {
    const url = `work/ReasonForLoss`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  reportarErro(data): Observable<any> {
    const url = `user/Support/Report`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  reportErroAdmin(data): Observable<any> {
    const url = `work/reports/obras`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  downloadPDF(data): Observable<Blob> {
    const url = `work/worksDetails/exportPDF`;

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    };

    return this._requestService.requestMethod(
      url,
      'POST',
      true,
      data,
      headers,
      'blob'
    );
  }

  editarTarefa(idTarefa: number, data: any): Observable<any> {
    const url = `work/${idTarefa}/edit-tasks`;
    return this._requestService.requestMethod(url, 'PUT', true, data);
  }

  solicitarNovaObra(data: any): Observable<any> {
  return this._requestService.requestMethod('work/reports/nova-obra', 'POST', true, data);
}

reportarErroContato(data: any): Observable<any> {
  return this._requestService.requestMethod('work/reports/contatos', 'POST', true, data);
}

downloadArquivoObra(idObra: number, nomeArquivo: string): Observable<Blob> {
  const url = `work/${idObra}/files/download/${encodeURIComponent(nomeArquivo)}`;
  return this._requestService.requestMethod(url, 'GET', true, null, null, 'blob');
}

}
